/**
 * Shopify Forms renders inside Shadow DOM, so theme.css cannot style inputs.
 * Styles are registered on window.formStyles and adopted into each form embed.
 *
 * Date fields use a custom calendar (native pickers cannot style weekends / popup chrome).
 */
(function () {
  window.formStyles = window.formStyles || new Map();

  var MONTH_NAMES = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];
  var WEEKDAYS = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];

  window.formStyles.set(
    'ipride-tournament-submission',
    [
      ':host {',
      "  --forms-body-font: 'Roboto', 'Segoe UI', Arial, sans-serif !important;",
      "  --forms-heading-font: 'Archivo', 'Helvetica Neue', Arial, sans-serif !important;",
      '  --forms-accent-color: #253B7B !important;',
      '  --forms-focus-outline-color: rgba(37, 59, 123, 0.12) !important;',
      '  color-scheme: light !important;',
      '  display: block !important;',
      '  width: 100% !important;',
      '  max-width: 1400px !important;',
      '  margin-left: auto !important;',
      '  margin-right: auto !important;',
      "  font-family: 'Roboto', 'Segoe UI', Arial, sans-serif !important;",
      '  color: #1a1a1a !important;',
      '  text-align: left !important;',
      '}',
      '',
      '#app-embed,',
      '[class*="_formContainer_"],',
      '[class*="_inline_"],',
      '[class*="_gridItemContent_"] {',
      '  max-width: 1400px !important;',
      '  margin-left: auto !important;',
      '  margin-right: auto !important;',
      '  padding: 50px 1.5rem 30px !important;',
      '  box-sizing: border-box !important;',
      '  text-align: left !important;',
      '  background: #fff !important;',
      '}',
      '',
      '[class*="_textHeading_"],',
      'h1, h2, h3 {',
      "  font-family: 'Archivo', 'Helvetica Neue', Arial, sans-serif !important;",
      '  font-size: clamp(1.6rem, 2.5vw, 2rem) !important;',
      '  font-weight: 700 !important;',
      '  color: #253B7B !important;',
      '  margin: 0 0 1rem !important;',
      '  text-transform: uppercase !important;',
      '  text-align: left !important;',
      '  line-height: 1.2 !important;',
      '}',
      '',
      '[class*="_textBody_"],',
      'p {',
      '  font-size: 1.1rem !important;',
      '  line-height: 1.7 !important;',
      '  color: #1a1a1a !important;',
      '  text-align: left !important;',
      '  margin: 0 0 1.5rem !important;',
      '}',
      '',
      '[class*="_formFieldset_"],',
      '[class*="_multiFieldLine_"],',
      '[class*="_nonMultineFieldLine_"],',
      '[class*="_fieldContainer_"] {',
      '  text-align: left !important;',
      '}',
      '',
      '[class*="_formFieldContainer_"] {',
      '  position: relative !important;',
      '  display: flex !important;',
      '  flex-direction: column !important;',
      '  align-items: stretch !important;',
      '  gap: 0.5rem !important;',
      '  text-align: left !important;',
      '}',
      '',
      '[class*="_formInputFieldLabel_"],',
      '[class*="_checkboxLegend_"],',
      '[class*="_radioLegend_"],',
      '[class*="_label_"]:not([class*="_formFileInput"]),',
      '[class*="_birthdayText_"]:not([class*="_withError_"]),',
      'label:not([class*="_formFileInputLabel_"]),',
      'legend {',
      '  position: static !important;',
      '  top: auto !important;',
      '  left: auto !important;',
      '  right: auto !important;',
      '  bottom: auto !important;',
      '  transform: none !important;',
      '  order: -1 !important;',
      '  display: block !important;',
      '  width: auto !important;',
      '  max-width: 100% !important;',
      '  margin: 0 !important;',
      '  padding: 0 !important;',
      '  pointer-events: auto !important;',
      '  z-index: auto !important;',
      '  font-weight: 700 !important;',
      '  color: #253B7B !important;',
      '  font-size: 0.95rem !important;',
      '  line-height: 1.3 !important;',
      '  text-align: left !important;',
      "  font-family: 'Roboto', 'Segoe UI', Arial, sans-serif !important;",
      '}',
      '',
      /* Space between Divisions / Updating a Tournament legends and options */
      '[class*="_checkboxLegend_"],',
      '[class*="_radioLegend_"] {',
      '  padding-bottom: 5px !important;',
      '}',
      '',
      /* File fields render the title as a body <p>, not a floating label */
      '[class*="_formFileInput_"] > [class*="_textBody_"],',
      '[class*="_formFileInput_"] > p {',
      '  position: static !important;',
      '  display: block !important;',
      '  width: auto !important;',
      '  max-width: 100% !important;',
      '  margin: 0 !important;',
      '  padding: 0 !important;',
      '  font-weight: 700 !important;',
      '  color: #253B7B !important;',
      '  font-size: 0.95rem !important;',
      '  line-height: 1.3 !important;',
      '  text-align: left !important;',
      "  font-family: 'Roboto', 'Segoe UI', Arial, sans-serif !important;",
      '}',
      '',
      '[class*="_formFieldContainer_"]:focus-within [class*="_formInputFieldLabel_"],',
      '[class*="_formInputFieldLabel_"][class*="_inputFilled_"],',
      '[class*="_formFieldContainer_"] [class*="_inputFilled_"] {',
      '  position: static !important;',
      '  transform: none !important;',
      '  top: auto !important;',
      '  left: auto !important;',
      '  width: auto !important;',
      '}',
      '',
      '[class*="_formFieldContainer_"]:has(textarea)::before,',
      '[class*="_formFieldContainer_"] [class*="_inputFilled_"]::before {',
      '  content: none !important;',
      '  display: none !important;',
      '}',
      '',
      'input:not([type="checkbox"]):not([type="radio"]):not([type="hidden"]):not([type="submit"]):not([type="button"]):not([type="file"]):not([type="date"]),',
      'textarea,',
      'select,',
      '[class*="_formInputField_"]:not([class*="_formFileInput"]),',
      '[class*="_textArea_"],',
      '[class*="_selectToggle_"],',
      '[class*="_formPhoneInputField_"] {',
      '  width: 100% !important;',
      '  max-width: 100% !important;',
      '  padding: 0.75rem 0.9rem !important;',
      '  border: 2px solid rgba(37, 59, 123, 0.25) !important;',
      '  border-radius: 4px !important;',
      "  font-family: 'Roboto', 'Segoe UI', Arial, sans-serif !important;",
      '  font-size: 1rem !important;',
      '  color: #1a1a1a !important;',
      '  background: #fff !important;',
      '  box-sizing: border-box !important;',
      '  box-shadow: none !important;',
      '}',
      '',
      'input:focus,',
      'textarea:focus,',
      'select:focus,',
      '[class*="_formInputField_"]:not([class*="_formFileInput"]):focus,',
      '[class*="_textArea_"]:focus,',
      '[class*="_selectToggle_"]:focus {',
      '  outline: none !important;',
      '  border-color: #253B7B !important;',
      '  box-shadow: 0 0 0 3px rgba(37, 59, 123, 0.12) !important;',
      '}',
      '',
      '[class*="_formFileInput_"] {',
      '  width: 100% !important;',
      '}',
      '',
      '[class*="_formFileInputField_"] {',
      '  position: relative !important;',
      '  display: flex !important;',
      '  align-items: center !important;',
      '  justify-content: center !important;',
      '  width: 100% !important;',
      '  max-width: 100% !important;',
      '  margin-top: 0.25rem !important;',
      '  padding: 0 !important;',
      '  border: 2px dashed rgba(37, 59, 123, 0.25) !important;',
      '  border-radius: 4px !important;',
      '  background: #fff !important;',
      '  cursor: pointer !important;',
      '  box-sizing: border-box !important;',
      '  box-shadow: none !important;',
      '}',
      '',
      '[class*="_formFileInputField_"]:has(:focus-visible) {',
      '  box-shadow: inset 0 0 0 2px #253B7B !important;',
      '}',
      '',
      /* Click overlay must stay absolute or Add file breaks */
      '[class*="_formFileInputLabel_"] {',
      '  position: absolute !important;',
      '  inset: 0 !important;',
      '  top: 0 !important;',
      '  right: 0 !important;',
      '  bottom: 0 !important;',
      '  left: 0 !important;',
      '  z-index: 0 !important;',
      '  order: 0 !important;',
      '  display: block !important;',
      '  width: auto !important;',
      '  max-width: none !important;',
      '  margin: 0 !important;',
      '  padding: 0 !important;',
      '  transform: none !important;',
      '  cursor: pointer !important;',
      '  pointer-events: auto !important;',
      '  color: transparent !important;',
      '  font-size: 0 !important;',
      '  line-height: 0 !important;',
      '  background: transparent !important;',
      '}',
      '',
      '[class*="_formFileInputContent_"] {',
      '  position: relative !important;',
      '  z-index: 1 !important;',
      '  display: flex !important;',
      '  align-items: center !important;',
      '  justify-content: center !important;',
      '  width: 100% !important;',
      '  padding: 1.5rem 0 !important;',
      '  pointer-events: none !important;',
      '  box-sizing: border-box !important;',
      '}',
      '',
      '[class*="_formFileInputButton_"] {',
      '  display: inline-block !important;',
      '  padding: 0.4rem 0.65rem !important;',
      '  border-radius: 4px !important;',
      '  background: #eef0f3 !important;',
      "  font-family: 'Roboto', 'Segoe UI', Arial, sans-serif !important;",
      '  font-size: 0.75rem !important;',
      '  font-weight: 600 !important;',
      '  line-height: 1.25 !important;',
      '  color: #253B7B !important;',
      '}',
      '',
      '[class*="_formFileInputNativeInput_"] {',
      '  position: absolute !important;',
      '  width: 1px !important;',
      '  height: 1px !important;',
      '  padding: 0 !important;',
      '  margin: -1px !important;',
      '  overflow: hidden !important;',
      '  clip: rect(0, 0, 0, 0) !important;',
      '  white-space: nowrap !important;',
      '  border: 0 !important;',
      '}',
      '',
      '[class*="_formFileInputFileName_"] {',
      '  display: flex !important;',
      '  align-items: center !important;',
      '  margin: 0 0.5rem !important;',
      "  font-family: 'Roboto', 'Segoe UI', Arial, sans-serif !important;",
      '  color: #1a1a1a !important;',
      '}',
      '',
      '[class*="_formFileInputCancelButton_"] {',
      '  display: flex !important;',
      '  height: 1.25rem !important;',
      '  padding: 0 !important;',
      '  border: none !important;',
      '  background: transparent !important;',
      '  cursor: pointer !important;',
      '  pointer-events: auto !important;',
      '}',
      '',
      '[data-testid="date-birthday"],',
      '[class*="_dateFieldContainer_"] {',
      '  max-width: 18rem !important;',
      '  width: 100% !important;',
      '}',
      '',
      '[data-testid="date-birthday"][data-ipride-enhanced="true"] {',
      '  max-width: 14rem !important;',
      '  position: relative !important;',
      '}',
      '',
      '[data-testid="date-birthday"][data-ipride-enhanced="true"] [class*="_dateFieldContainer_"] {',
      '  position: absolute !important;',
      '  width: 1px !important;',
      '  height: 1px !important;',
      '  padding: 0 !important;',
      '  margin: -1px !important;',
      '  overflow: hidden !important;',
      '  clip: rect(0, 0, 0, 0) !important;',
      '  white-space: nowrap !important;',
      '  border: 0 !important;',
      '}',
      '',
      '.ipride-date-wrap {',
      '  position: relative !important;',
      '  width: 100% !important;',
      '  max-width: 14rem !important;',
      '}',
      '',
      '.ipride-date-display {',
      '  display: flex !important;',
      '  align-items: center !important;',
      '  justify-content: space-between !important;',
      '  width: 100% !important;',
      '  margin-top: 0.25rem !important;',
      '  padding: 0.75rem 0.9rem !important;',
      '  border: 2px solid rgba(37, 59, 123, 0.25) !important;',
      '  border-radius: 4px !important;',
      "  font-family: 'Roboto', 'Segoe UI', Arial, sans-serif !important;",
      '  font-size: 1rem !important;',
      '  font-weight: 400 !important;',
      '  color: #1a1a1a !important;',
      '  background: #fff !important;',
      '  box-sizing: border-box !important;',
      '  cursor: pointer !important;',
      '  text-align: left !important;',
      '}',
      '',
      '.ipride-date-display:focus {',
      '  outline: none !important;',
      '  border-color: #253B7B !important;',
      '  box-shadow: 0 0 0 3px rgba(37, 59, 123, 0.12) !important;',
      '}',
      '',
      '.ipride-date-display.is-placeholder {',
      '  color: #5a6478 !important;',
      '}',
      '',
      '.ipride-date-popup {',
      '  position: absolute !important;',
      '  z-index: 40 !important;',
      '  top: calc(100% + 0.35rem) !important;',
      '  left: 0 !important;',
      '  width: 17.5rem !important;',
      '  padding: 0.85rem !important;',
      '  border: 1px solid rgba(37, 59, 123, 0.18) !important;',
      '  border-radius: 6px !important;',
      '  background: #eef0f3 !important;',
      '  box-shadow: 0 8px 24px rgba(26, 32, 44, 0.16) !important;',
      '  color: #1a1a1a !important;',
      '  box-sizing: border-box !important;',
      '}',
      '',
      '.ipride-date-popup[hidden] {',
      '  display: none !important;',
      '}',
      '',
      '.ipride-date-popup__header {',
      '  display: flex !important;',
      '  align-items: center !important;',
      '  justify-content: space-between !important;',
      '  gap: 0.5rem !important;',
      '  margin-bottom: 0.75rem !important;',
      '}',
      '',
      '.ipride-date-popup__title {',
      '  flex: 1 !important;',
      '  margin: 0 !important;',
      '  font-size: 0.95rem !important;',
      '  font-weight: 700 !important;',
      '  color: #253B7B !important;',
      '  text-align: center !important;',
      '}',
      '',
      '.ipride-date-popup__nav {',
      '  width: 2rem !important;',
      '  height: 2rem !important;',
      '  border: none !important;',
      '  border-radius: 4px !important;',
      '  background: #fff !important;',
      '  color: #253B7B !important;',
      '  font-size: 1.1rem !important;',
      '  font-weight: 700 !important;',
      '  cursor: pointer !important;',
      '  line-height: 1 !important;',
      '}',
      '',
      '.ipride-date-popup__nav:hover {',
      '  background: #dde2ea !important;',
      '}',
      '',
      '.ipride-date-popup__weekdays,',
      '.ipride-date-popup__grid {',
      '  display: grid !important;',
      '  grid-template-columns: repeat(7, minmax(0, 1fr)) !important;',
      '  gap: 0.2rem !important;',
      '}',
      '',
      '.ipride-date-popup__weekdays span {',
      '  text-align: center !important;',
      '  font-size: 0.75rem !important;',
      '  font-weight: 700 !important;',
      '  color: #3a4556 !important;',
      '  padding: 0.2rem 0 !important;',
      '}',
      '',
      '.ipride-date-popup__day {',
      '  height: 2rem !important;',
      '  border: none !important;',
      '  border-radius: 4px !important;',
      '  background: transparent !important;',
      '  color: #1a1a1a !important;',
      '  font-size: 0.875rem !important;',
      '  font-weight: 600 !important;',
      '  cursor: pointer !important;',
      '}',
      '',
      '.ipride-date-popup__day:hover:not(:disabled) {',
      '  background: #d5dbe4 !important;',
      '  color: #1a1a1a !important;',
      '}',
      '',
      '.ipride-date-popup__day.is-outside {',
      '  color: #8a93a3 !important;',
      '}',
      '',
      '.ipride-date-popup__day.is-selected {',
      '  background: #253B7B !important;',
      '  color: #fff !important;',
      '}',
      '',
      '.ipride-date-popup__day:disabled {',
      '  color: #a8b0bc !important;',
      '  cursor: not-allowed !important;',
      '  background: transparent !important;',
      '}',
      '',
      '[class*="_checkboxFieldSet_"],',
      '[class*="_radioFieldSet_"],',
      '[class*="_formFieldset_"]:has([class*="_checkbox"]),',
      '[class*="_formFieldset_"]:has(input[type="checkbox"]),',
      '[class*="_formFieldset_"]:has(input[type="radio"]),',
      'fieldset:has(input[type="checkbox"]),',
      'fieldset:has(input[type="radio"]) {',
      '  border: none !important;',
      '  box-shadow: none !important;',
      '  outline: none !important;',
      '  background: transparent !important;',
      '  padding-left: 0 !important;',
      '  padding-right: 0 !important;',
      '}',
      '',
      '[class*="_checkboxFieldSet_"],',
      '[class*="_radioFieldSet_"],',
      '[class*="_checkboxWrapper_"] {',
      '  display: flex !important;',
      '  flex-wrap: wrap !important;',
      '  gap: 0.75rem 1.25rem !important;',
      '  border: none !important;',
      '  box-shadow: none !important;',
      '  background: transparent !important;',
      '}',
      '',
      '[class*="_checkboxField_"],',
      '[class*="_radioField_"] {',
      '  display: inline-flex !important;',
      '  align-items: center !important;',
      '  gap: 0.5rem !important;',
      '  padding: 0 !important;',
      '  border: none !important;',
      '  border-radius: 0 !important;',
      '  box-shadow: none !important;',
      '  font-weight: 600 !important;',
      '  color: #253B7B !important;',
      '  background: transparent !important;',
      '}',
      '',
      'input[type="checkbox"],',
      'input[type="radio"],',
      '[class*="_checkboxInput_"],',
      '[class*="_radioInput_"] {',
      '  width: 1rem !important;',
      '  height: 1rem !important;',
      '  accent-color: #253B7B !important;',
      '}',
      '',
      '[class*="_formError_"],',
      '[class*="_error_"] {',
      '  color: #b42828 !important;',
      '  font-size: 0.875rem !important;',
      '}',
      '',
      '[class*="_formSubmitButton_"],',
      'button[type="submit"] {',
      '  display: inline-flex !important;',
      '  align-items: center !important;',
      '  justify-content: center !important;',
      '  margin-top: 1.5rem !important;',
      '  padding: 0.85rem 1.5rem !important;',
      '  border: none !important;',
      '  border-radius: 4px !important;',
      '  background: #253B7B !important;',
      '  color: #fff !important;',
      "  font-family: 'Roboto', 'Segoe UI', Arial, sans-serif !important;",
      '  font-size: 1rem !important;',
      '  font-weight: 700 !important;',
      '  cursor: pointer !important;',
      '  text-transform: none !important;',
      '  box-shadow: none !important;',
      '}',
      '',
      '[class*="_formSubmitButton_"]:hover,',
      'button[type="submit"]:hover {',
      '  background: #1c2f66 !important;',
      '}',
      '',
      '@media (max-width: 768px) {',
      '  #app-embed,',
      '  [class*="_formContainer_"],',
      '  [class*="_inline_"],',
      '  [class*="_gridItemContent_"] {',
      '    padding: 40px 1rem 24px !important;',
      '  }',
      '}',
    ].join('\n')
  );

  function setReactInputValue(input, value) {
    if (!input) return;
    var descriptor = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value');
    if (descriptor && descriptor.set) {
      descriptor.set.call(input, value);
    } else {
      input.value = value;
    }
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    input.dispatchEvent(new Event('blur', { bubbles: true }));
  }

  function getPartKey(labelText) {
    var text = (labelText || '').replace(/\s+/g, '').toUpperCase();
    if (text === 'DD' || text === 'D' || text.indexOf('DAY') === 0) return 'day';
    if (text === 'MM' || text === 'M' || text.indexOf('MONTH') === 0) return 'month';
    if (text === 'YYYY' || text === 'YY' || text === 'Y' || text.indexOf('YEAR') === 0) return 'year';
    return '';
  }

  function mapDatePartInputs(container) {
    var map = {};
    container.querySelectorAll('input[type="text"]').forEach(function (input) {
      var labelText = '';
      var labelledBy = input.getAttribute('aria-labelledby');
      if (labelledBy) {
        var label = null;
        try {
          label = container.querySelector('#' + CSS.escape(labelledBy));
        } catch (err) {
          label = container.querySelector('[id="' + labelledBy.replace(/"/g, '\\"') + '"]');
        }
        if (label) labelText = label.textContent || '';
      }
      if (!labelText) {
        var wrap = input.closest('[class*="_formFieldContainer_"]');
        var nearbyLabel = wrap && wrap.querySelector('label');
        if (nearbyLabel) labelText = nearbyLabel.textContent || '';
      }
      var key = getPartKey(labelText);
      if (key) map[key] = input;
    });
    return map;
  }

  function pad2(value) {
    var str = String(value || '');
    return str.length === 1 ? '0' + str : str;
  }

  function readMappedDate(map) {
    if (!map.year || !map.month || !map.day) return '';
    var year = (map.year.value || '').trim();
    var month = pad2((map.month.value || '').trim());
    var day = pad2((map.day.value || '').trim());
    if (year.length !== 4 || month.length !== 2 || day.length !== 2) return '';
    return year + '-' + month + '-' + day;
  }

  function formatDisplayDate(iso) {
    if (!iso) return 'Select date';
    var parts = iso.split('-');
    if (parts.length !== 3) return iso;
    return parts[1] + '/' + parts[2] + '/' + parts[0];
  }

  function parseIso(iso) {
    if (!iso) return null;
    var parts = iso.split('-').map(Number);
    if (parts.length !== 3 || parts.some(isNaN)) return null;
    return new Date(parts[0], parts[1] - 1, parts[2]);
  }

  function toIso(date) {
    return date.getFullYear() + '-' + pad2(date.getMonth() + 1) + '-' + pad2(date.getDate());
  }

  function getDateFieldLabel(container) {
    var label = container.querySelector('[class*="_birthdayText_"]:not([class*="_withError_"])');
    if (label && label.textContent) return label.textContent.trim().toLowerCase();
    var parent = container.parentElement;
    if (!parent) return '';
    var outerLabel = parent.querySelector('[class*="_formInputFieldLabel_"], label, legend');
    return (outerLabel && outerLabel.textContent || '').trim().toLowerCase();
  }

  function isStartDateLabel(label) {
    return label.indexOf('start') !== -1;
  }

  function isEndDateLabel(label) {
    return label.indexOf('end') !== -1;
  }

  function syncPickerToForms(picker) {
    if (!picker || !picker._iprideDateMap) return;
    var map = picker._iprideDateMap;
    if (!picker.value) {
      setReactInputValue(map.year, '');
      setReactInputValue(map.month, '');
      setReactInputValue(map.day, '');
      return;
    }
    var parts = picker.value.split('-');
    if (parts.length !== 3) return;
    setReactInputValue(map.year, parts[0]);
    setReactInputValue(map.month, parts[1]);
    setReactInputValue(map.day, parts[2]);
  }

  function closeAllPopups(root) {
    if (!root) return;
    root.querySelectorAll('.ipride-date-popup').forEach(function (popup) {
      popup.hidden = true;
    });
  }

  function createCustomDatePicker(container, map, initialValue) {
    var wrap = document.createElement('div');
    wrap.className = 'ipride-date-wrap';

    var valueInput = document.createElement('input');
    valueInput.type = 'hidden';
    valueInput.className = 'ipride-date-picker';
    valueInput.value = initialValue || '';
    valueInput._iprideDateMap = map;

    var display = document.createElement('button');
    display.type = 'button';
    display.className = 'ipride-date-display';
    display.setAttribute('aria-haspopup', 'dialog');
    display.setAttribute('aria-expanded', 'false');

    var popup = document.createElement('div');
    popup.className = 'ipride-date-popup';
    popup.hidden = true;
    popup.setAttribute('role', 'dialog');

    var viewDate = parseIso(initialValue) || new Date();
    viewDate = new Date(viewDate.getFullYear(), viewDate.getMonth(), 1);

    function updateDisplay() {
      var hasValue = !!valueInput.value;
      display.textContent = formatDisplayDate(valueInput.value);
      display.classList.toggle('is-placeholder', !hasValue);
    }

    function setValue(iso, silent) {
      valueInput.value = iso || '';
      updateDisplay();
      syncPickerToForms(valueInput);
      if (!silent) {
        valueInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function renderCalendar() {
      var selected = valueInput.value;
      var minDate = parseIso(valueInput.min || '');
      var openIso = selected || valueInput.min || toIso(new Date());
      var openDate = parseIso(openIso) || new Date();

      if (!selected && valueInput.min) {
        viewDate = new Date(openDate.getFullYear(), openDate.getMonth(), 1);
      }

      var year = viewDate.getFullYear();
      var month = viewDate.getMonth();
      var firstDay = new Date(year, month, 1);
      var startOffset = firstDay.getDay();
      var gridStart = new Date(year, month, 1 - startOffset);

      var html = '';
      html += '<div class="ipride-date-popup__header">';
      html += '<button type="button" class="ipride-date-popup__nav" data-nav="-1" aria-label="Previous month">‹</button>';
      html += '<p class="ipride-date-popup__title">' + MONTH_NAMES[month] + ' ' + year + '</p>';
      html += '<button type="button" class="ipride-date-popup__nav" data-nav="1" aria-label="Next month">›</button>';
      html += '</div>';
      html += '<div class="ipride-date-popup__weekdays">';
      WEEKDAYS.forEach(function (day) {
        html += '<span>' + day + '</span>';
      });
      html += '</div><div class="ipride-date-popup__grid">';

      for (var i = 0; i < 42; i += 1) {
        var cell = new Date(gridStart.getFullYear(), gridStart.getMonth(), gridStart.getDate() + i);
        var iso = toIso(cell);
        var isOutside = cell.getMonth() !== month;
        var isSelected = iso === selected;
        var disabled = !!(minDate && cell < minDate);
        var classes = 'ipride-date-popup__day';
        if (isOutside) classes += ' is-outside';
        if (isSelected) classes += ' is-selected';
        html +=
          '<button type="button" class="' +
          classes +
          '" data-date="' +
          iso +
          '"' +
          (disabled ? ' disabled' : '') +
          '>' +
          cell.getDate() +
          '</button>';
      }
      html += '</div>';
      popup.innerHTML = html;
    }

    function openPopup() {
      var root = container.getRootNode();
      closeAllPopups(root);
      if (!valueInput.value && valueInput.min) {
        var minParsed = parseIso(valueInput.min);
        if (minParsed) viewDate = new Date(minParsed.getFullYear(), minParsed.getMonth(), 1);
      } else if (valueInput.value) {
        var current = parseIso(valueInput.value);
        if (current) viewDate = new Date(current.getFullYear(), current.getMonth(), 1);
      }
      renderCalendar();
      popup.hidden = false;
      display.setAttribute('aria-expanded', 'true');
    }

    function closePopup() {
      popup.hidden = true;
      display.setAttribute('aria-expanded', 'false');
    }

    display.addEventListener('click', function (event) {
      event.preventDefault();
      if (popup.hidden) openPopup();
      else closePopup();
    });

    popup.addEventListener('click', function (event) {
      var nav = event.target.closest('[data-nav]');
      if (nav) {
        event.preventDefault();
        viewDate = new Date(viewDate.getFullYear(), viewDate.getMonth() + Number(nav.getAttribute('data-nav')), 1);
        renderCalendar();
        return;
      }
      var dayBtn = event.target.closest('[data-date]');
      if (dayBtn && !dayBtn.disabled) {
        event.preventDefault();
        setValue(dayBtn.getAttribute('data-date'));
        closePopup();
      }
    });

    valueInput.addEventListener('change', function () {
      updateDisplay();
    });

    // Expose helpers used by start/end linking
    valueInput._iprideSetMin = function (minIso) {
      if (minIso) valueInput.min = minIso;
      else valueInput.removeAttribute('min');
      if (!popup.hidden) renderCalendar();
    };
    valueInput._iprideOpenTo = function (iso) {
      var parsed = parseIso(iso);
      if (parsed) viewDate = new Date(parsed.getFullYear(), parsed.getMonth(), 1);
    };

    wrap.appendChild(valueInput);
    wrap.appendChild(display);
    wrap.appendChild(popup);
    updateDisplay();

    var rootNode = container.getRootNode();
    if (rootNode && !rootNode._iprideDateOutsideClose) {
      rootNode._iprideDateOutsideClose = true;
      rootNode.addEventListener(
        'click',
        function (event) {
          if (event.target.closest && event.target.closest('.ipride-date-wrap')) return;
          closeAllPopups(rootNode);
        },
        true
      );
    }

    return wrap;
  }

  function linkStartEndDates(root) {
    if (!root) return;
    var startPicker = null;
    var endPicker = null;

    root.querySelectorAll('[data-testid="date-birthday"][data-ipride-enhanced="true"]').forEach(function (container) {
      var label = getDateFieldLabel(container);
      var picker = container.querySelector('.ipride-date-picker');
      if (!picker) return;
      if (isStartDateLabel(label)) startPicker = picker;
      if (isEndDateLabel(label)) endPicker = picker;
    });

    if (!startPicker || !endPicker || startPicker.dataset.iprideDateLinked === 'true') return;
    startPicker.dataset.iprideDateLinked = 'true';
    endPicker.dataset.iprideDateLinked = 'true';

    function applyStartToEnd() {
      var startVal = startPicker.value;
      if (!startVal) {
        if (startPicker._iprideSetMin) startPicker._iprideSetMin('');
        if (endPicker._iprideSetMin) endPicker._iprideSetMin('');
        return;
      }

      if (endPicker._iprideSetMin) endPicker._iprideSetMin(startVal);
      else endPicker.min = startVal;

      if (endPicker._iprideOpenTo) endPicker._iprideOpenTo(startVal);

      if (!endPicker.value || endPicker.value < startVal) {
        endPicker.value = startVal;
        syncPickerToForms(endPicker);
        endPicker.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    startPicker.addEventListener('change', applyStartToEnd);
    applyStartToEnd();
  }

  function enhanceDateField(container) {
    if (!container || container.dataset.iprideEnhanced === 'true') return;
    var map = mapDatePartInputs(container);
    if (!map.day || !map.month || !map.year) return;

    container.dataset.iprideEnhanced = 'true';

    var wrap = createCustomDatePicker(container, map, readMappedDate(map));
    var dateParts = container.querySelector('[class*="_dateFieldContainer_"]');
    if (dateParts && dateParts.parentNode) {
      dateParts.parentNode.insertBefore(wrap, dateParts);
    } else {
      container.appendChild(wrap);
    }
  }

  function enhanceShadowRoot(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('[data-testid="date-birthday"]').forEach(enhanceDateField);
    linkStartEndDates(root);
  }

  function scanForms() {
    document.querySelectorAll('shopify-forms-embed').forEach(function (embed) {
      if (embed.shadowRoot) enhanceShadowRoot(embed.shadowRoot);
    });
    document.querySelectorAll('[data-form-root="true"]').forEach(function (host) {
      var embed = host.querySelector('shopify-forms-embed');
      if (embed && embed.shadowRoot) enhanceShadowRoot(embed.shadowRoot);
    });
  }

  function observeEmbed(embed) {
    if (!embed || embed.dataset.iprideDateObserver === 'true') return;
    embed.dataset.iprideDateObserver = 'true';

    var tryEnhance = function () {
      if (embed.shadowRoot) enhanceShadowRoot(embed.shadowRoot);
    };

    tryEnhance();

    var outerObserver = new MutationObserver(tryEnhance);
    outerObserver.observe(embed, { childList: true, subtree: true, attributes: true });

    var attachShadowObserver = function () {
      if (!embed.shadowRoot || embed.dataset.iprideShadowObserver === 'true') return;
      embed.dataset.iprideShadowObserver = 'true';
      var shadowObserver = new MutationObserver(function () {
        enhanceShadowRoot(embed.shadowRoot);
      });
      shadowObserver.observe(embed.shadowRoot, { childList: true, subtree: true });
      enhanceShadowRoot(embed.shadowRoot);
    };

    attachShadowObserver();
    var poll = window.setInterval(function () {
      if (embed.shadowRoot) {
        attachShadowObserver();
        enhanceShadowRoot(embed.shadowRoot);
        window.clearInterval(poll);
      }
    }, 200);
    window.setTimeout(function () {
      window.clearInterval(poll);
    }, 15000);
  }

  function initDatePickers() {
    scanForms();
    document.querySelectorAll('shopify-forms-embed').forEach(observeEmbed);

    var docObserver = new MutationObserver(function () {
      document.querySelectorAll('shopify-forms-embed').forEach(observeEmbed);
      scanForms();
    });
    docObserver.observe(document.documentElement, { childList: true, subtree: true });

    if (!document.documentElement.dataset.iprideDateDocClose) {
      document.documentElement.dataset.iprideDateDocClose = 'true';
      document.addEventListener(
        'click',
        function (event) {
          var path = event.composedPath ? event.composedPath() : [];
          var insidePicker = path.some(function (node) {
            return node && node.classList && node.classList.contains('ipride-date-wrap');
          });
          if (insidePicker) return;
          document.querySelectorAll('shopify-forms-embed').forEach(function (embed) {
            if (embed.shadowRoot) closeAllPopups(embed.shadowRoot);
          });
        },
        true
      );
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDatePickers);
  } else {
    initDatePickers();
  }
})();
